import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  height: 100%;
  margin: 0 auto;
  background: unset;
  aspect-ratio: 4/3;

  video {
    position: static;
    border-radius: 5px;
    max-width: 100%;
    height: 100%;
  }
`;
